<!-- 讯息中心 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="page-container" shadow="never">
        <template slot="header">
          <el-form size="small">
            <el-form-item :label="$t('text.sblx')">
              <el-select v-model="queryParams.devtype" placeholder="" clearable>
                <el-option
                  v-for="item in devtypes"
                  :key="item.key"
                  :value="item.value"
                  :label="item.key"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('text.dzmc')">
              <el-input
                v-model="queryParams.orgname"
                clearable
                :placeholder="$t('placeholder.dzmc')"
              />
            </el-form-item>
            <el-form-item :label="$t('text.kssj')">
              <el-date-picker
                v-model="queryParams.starttime"
                type="date"
                clearable
                :placeholder="$t('placeholder.kssj')"
                value-format="yyyy-MM-dd 00:00:00"
              />
            </el-form-item>
            <el-form-item :label="$t('text.jssj')">
              <el-date-picker
                v-model="queryParams.endtime"
                type="date"
                :placeholder="$t('placeholder.jssj')"
                value-format="yyyy-MM-dd 23:59:59"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                size="small"
                :loading="loading"
                @click="handleSearch"
              >
                {{ $t('button.cx') }}
              </el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <div class="table-container">
            <el-table
              v-loading="loading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.7)"
              height="100%"
              :data="tableData"
            >
              <template slot="empty">
                <div class="table-no-data" />
              </template>
              <el-table-column
                :label="$t('text.xh')"
                type="index"
                align="center"
                width="80"
              />
              <el-table-column
                :label="$t('text.dzmc')"
                align="center"
                show-overflow-tooltip
                prop="orgname"
              />
              <el-table-column
                :label="$t('text.rq')"
                align="center"
                width="150"
                prop="createtime"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.createtime | dateFilter('yyyy-MM-dd hh:mm:ss') }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('text.cjqsn')"
                align="center"
                prop="gatewaysn"
              />
              <el-table-column
                :label="$t('text.nbqsn')"
                align="center"
                prop="sn"
              />
              <el-table-column
                label="设备类型"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.devtype==='0' ?'组串':scope.row.devtype==='1'?'储能':scope.row.devtype==='2'?'气象':'电表' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('text.bjlx')"
                align="center"
                prop="alarmdesc"
              />
              <el-table-column
                :label="$t('text.bjzt')"
                align="center"
                prop="status"
              >
                <template v-slot="scope">
                  <span v-if="scope.row.status==='1'">{{ $t('text.ycl') }}</span>
                  <span v-if="scope.row.status==='0'">{{ $t('text.wcl') }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('text.cz')"
                align="center"
              >
                <template v-slot="scope">
                  <el-button
                    v-if="scope.row.status === '0'"
                    type="text"
                    style="color:#1CC197"
                    icon="el-icon-finished"
                    size="small"
                    @click="handleDispose(scope.row)"
                  >{{ $t('button.cl') }}</el-button>
                  <el-button
                    type="text"
                    class="danger"
                    icon="el-icon-delete"
                    size="small"
                    @click="handleDelete(scope.row)"
                  >{{ $t('button.sc') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page-container">
            <el-pagination
              v-show="total > 0"
              background
              layout="total,prev, pager, next,jumper"
              :current-page.sync="pageNum"
              :total="total"
              @current-change="handlePageChange"
            />
          </div>
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import { QueryAlarms, HandleAlarm, BatchDelAlarms } from '@apis/Alarms'
export default {
  data () {
    return {
      loading: false, // 表格加载
      total: 0,
      pageSize: 15,
      pageNum: 1,
      tableData: [], // 表格数据
      queryParams: { }, // 表格查询条件
      devtypes: [
        { key: '组串', value: '0' },
        { key: '储能', value: '1' },
        { key: '气象', value: '2' },
        { key: '电表', value: '3' },
      ],
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {

    /** 分页切换 */
    handlePageChange () {
      this.getTableData()
    },

    /** 获取表格数据 */
    getTableData () {
      this.loading = true
      QueryAlarms({
        page: this.pageNum,
        perPage: this.pageSize,
        orderBy: 'createtime desc',
        whereCondition: JSON.stringify(this.queryParams)
      }).then(res => {
        this.loading = false
        this.tableData = res.data.queryResults
        this.total = res.data.totalCount
      }).catch(() => {
        this.loading = false
      })
    },
    /** 搜索表格数据 */
    handleSearch () {
      this.pageNum = 1
      this.getTableData()
    },
    /** 处理报警 */
    handleDispose (row) {
      this.$confirm(this.$t('notice.sfcl'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
      })
        .then(() => {
          return HandleAlarm({ id: row.id })
        })
        .then(() => {
          this.$msgSuccess(this.$t('notice.clcg'))
          this.handleQuery()
        })
        .catch(() => {})
    },
    /** 删除报警 */
    handleDelete (row) {
      this.$confirm(this.$t('notice.sfsc'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      })
        .then(() => {
          return BatchDelAlarms({ ids: [row.id] })
        })
        .then(() => {
          this.$msgSuccess(this.$t('notice.sccg'))
          this.handleQuery()
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.page-container{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #1d3666;
  border-color: #1d3666;
}

.page-container>>>.el-card__header{
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.page-container>>>.el-card__header .el-form{
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(4,1fr) 100px;
  column-gap: 15px;
}
.page-container>>>.el-card__header .el-form-item{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0;
}
.page-container>>>.el-card__header .el-form-item .el-form-item__label{
  width: 80px;
}
.page-container>>>.el-card__header .el-form-item .el-form-item__content{
  flex: 1;
}

.page-container>>>.el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 15px 0;
  box-sizing: border-box;
}
.page-container>>>.el-card__body .table-container{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0;
  box-sizing: border-box;
}

.page-container>>>.el-card__body .page-container{
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

</style>

